import { generateAutomationName } from "../../helpers/generateAutomationName";

export const switcherDataAutomation = {
    container: generateAutomationName("home", ["granularity", "switcher", "container"]),
    title: generateAutomationName("home", ["granularity", "switcher", "title"]),
    switcher: generateAutomationName("home", ["granularity", "switcher"]),
};
